import { InlineFormattedNumber, Text } from '@talos/kyoko';

interface InitialValueTextProps {
  value?: string;
  currency?: string;
}

export const InitialValueText = ({ value, currency }: InitialValueTextProps) => {
  return (
    <Text color="colorTextSubtle" fontSize="fontSizeSm">
      Current: {value ? <InlineFormattedNumber number={value} currency={currency} truncate={false} /> : '-'}
    </Text>
  );
};
